import type { DemoKey } from './keys';

export const ar: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'الهندسة · 3D',
  'panel.figure': 'الشكل',
  'panel.dims': 'الأبعاد',
  'panel.style': 'المظهر',
  'panel.lines': 'خطوط خاصة',
  'style.body': 'الجسم',
  'style.line': 'الخط',
  'style.cut': 'المقطع',
  'style.labels': 'تسميات الرؤوس',
  'group.face': 'أقطار الوجوه / المولدات',
  'group.space': 'الأقطار / المحاور / الوسطاء',
  'split.label': 'المقطع',
  'btn.animate': 'تحريك',
  'btn.reset': 'إعادة تعيين',
  'hint.line1': 'اسحب للتدوير · مرر للتكبير',
  'hint.line2': 'انقر على خط لتحديده',
  'fig.cuboid': 'متوازي مستطيلات',
  'fig.cube': 'مكعب',
  'fig.triPrism': 'موشور ثلاثي',
  'fig.hexPrism': 'موشور سداسي',
  'fig.tetrahedron': 'رباعي السطوح',
  'fig.squarePyramid': 'هرم رباعي',
  'fig.cylinder': 'أسطوانة',
  'fig.cone': 'مخروط',
  'fig.sphere': 'كرة',
  'fig.frustumPyramid': 'هرم ناقص',
  'fig.frustumCone': 'مخروط ناقص',
  'dim.length': 'الطول',
  'dim.width': 'العرض',
  'dim.height': 'الارتفاع',
  'dim.side': 'الضلع',
  'dim.radius': 'نصف القطر',
  'dim.r1': 'نصف القطر السفلي',
  'dim.r2': 'نصف القطر العلوي',
  'dim.sideBase': 'ضلع القاعدة',
  'dim.sideTop': 'ضلع القمة',
  'info.face': 'وجه',
  'info.center': 'عبر المركز',
  'info.diagonal': 'قطر',
  'info.axial': 'قطر محوري',
  'info.diameter': 'القطر',
  'info.generator': 'مولد',
  'info.axis': 'محور',
  'info.height': 'ارتفاع',
  'info.median': 'متوسط',
  'info.apothem': 'عمودي',
  'info.diameterBase': 'قطر القاعدة',
  'info.diameterTop': 'قطر القمة',
};
